// Načítání uvnitř stránky (karta, seznam): malý pulzující indikátor s textem. Celostránkový tichý
// stav bez blikání řeší prihlaseni/TichyStav.tsx.
import './komponenty.css';

export function Nacitani({ text = 'Načítám…' }: { text?: string }) {
  return (
    <span className="nacitani" role="status" aria-live="polite" aria-busy="true">
      <span className="nacitani__tecka" aria-hidden="true" />
      {text}
    </span>
  );
}
